var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.916,
    height: 20.916,
    viewBox: "0 0 20.916 20.916",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedin",
    transform: "translate(-179.542 -997.542)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-linkedin-in",
    "data-name": "Icon awesome-linkedin-in",
    d: "M4.682,20.916H.345V6.952H4.682ZM2.511,5.047A2.523,2.523,0,1,1,5.023,2.512,2.533,2.533,0,0,1,2.511,5.047Zm18.4,15.869H16.584v-6.8c0-1.62-.033-3.7-2.255-3.7-2.255,0-2.6,1.76-2.6,3.581v6.914H7.4V6.952h4.159v1.9h.061a4.556,4.556,0,0,1,4.1-2.255c4.389,0,5.2,2.89,5.2,6.644v7.671Z",
    transform: "translate(179.542 997.542)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.09e2541fc9c33c2e0d625566483a5621.svg";
export { ForwardRef as ReactComponent };